module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_7016.be4c4c13.png";